module.exports = "<span ng-bind=\"$parent.row.activation.always_on.activated_date | date:'MMM d, y'\"></span>"